import React,{Fragment} from "react"
import ListItem from '@material-ui/core/ListItem'
import { withStyles } from '@material-ui/core/styles'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'
import InfoOutlineIcon from '@material-ui/icons/InfoOutline'
import RemoveIcon from '@material-ui/icons/Close'
import { withTheme } from '@material-ui/core/styles'
import EditIcon from '@material-ui/icons/Edit'
import moment from 'moment'
import Grid from '@material-ui/core/Grid'
import { I18n } from 'react-redux-i18n'
import ReactSwipeEvents from 'react-swipe-events'
import { Link } from 'react-router-dom'
import CircularProgress from '@material-ui/core/CircularProgress'

const styles = theme => ({
  mainList:{
    width: '100%',
    color: '#009fe3',
    padding: '12px 0',
    cursor: 'pointer'
  },
  mainListIcon: {
    display: 'inline-block'
  },
  mainListText: {
    display: 'inline-block'
  },
  slider:{
    transition: '0.1s',
    position: 'relative'
  },
  sliderDiv:{
    height: '100%',
    position: 'absolute',
    top: 0,
    left: -204,
    zIndex: 50,
    padding: '0 24px',
    width: '156px',
    backgroundColor: theme.palette.primary.light,
    lineHeight: '100%'
  },
  button: {
    margin: 0,
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)'
  },
  icon: {
    height: '1.4em',
    lineHeight: '1.4em',
    fontSize: '2em'
  },
  secondaryItem:{
    marginLeft: 10,
    display: 'inline-block',
  },
  primaryItem:{
    width: '90px',
    display: 'inline-block',
  }
});

const open = 204
const closed = 0

class Appointment extends React.Component {


  state = {
    open: false,
    position: closed
  }

  toggleSlide = () =>{
    if(this.state.open){
        this.setState({open: false, position: closed})
    }else{
        this.setState({open: true, position: open})
    }
  }

  onSwiping = (e, originalX, originalY, currentX, currentY, deltaX, deltaY) => {
    let pos = deltaX

    if(this.state.open){
      pos = deltaX+open
    }

    if(pos > open) pos=open
    this.setState({position: pos})
  }

  onSwiped = (e, originalX, originalY, endX, endY, deltaX, deltaY) => {

    let pos = deltaX

    if(this.state.open){
      pos = deltaX+open
    }

    if(pos>closed+100){
      this.setState({open: true, position: open})
    }else{
      this.setState({open: false, position: closed})
    }
  }

  render(){
    return(
      <ReactSwipeEvents onSwiping={this.onSwiping} onSwiped={this.onSwiped}>
        <Fragment>
          <ListItem className={this.props.classes.slider} style={{left: this.state.position+'px'}}>
            <div ref={this.sliderDiv} className={this.props.classes.sliderDiv}>
              <Link to={"/appointment/info/"+this.props.appointment.id}>
                <IconButton className={this.props.classes.button} aria-label="Delete">
                  <InfoOutlineIcon />
                </IconButton>
              </Link>
              <Link to={"/appointment/edit/"+this.props.appointment.id}>
                <IconButton className={this.props.classes.button} aria-label="Delete">
                  <EditIcon />
                </IconButton>
              </Link>
              {this.props.deleteAppointment.deleting ? (
                <IconButton className={this.props.classes.button}>
                  <CircularProgress/>
                </IconButton>
              ) : (
                <IconButton className={this.props.classes.button} onClick={() => this.props.deleteAppointmentEvent(this.props.appointment.id)} aria-label="Add an alarm">
                  <RemoveIcon />
                </IconButton>
              )}
            </div>
            <MainList onClick={this.toggleSlide} appointment={this.props.appointment} selectedDate={this.props.selectedDate} classes={this.props.classes} />
          </ListItem>
          <Divider />
        </Fragment>
      </ReactSwipeEvents>
    )
  }
}

function MainList(props){
  let timeItem = null
  let fromItem = null

  const begin = moment(props.appointment.van_datum+props.appointment.van_tijd, 'YYYYMMDDhhmm')
  const end = moment(props.appointment.tot_datum+props.appointment.tot_tijd, 'YYYYMMDDhhmm')

  if(props.appointment.van_datum === props.appointment.tot_datum){
    timeItem = <span className={props.classes.primaryItem}>{props.appointment.van_tijd + " - " + props.appointment.tot_tijd}</span>
  }else{
    if(props.selectedDate.diff(moment(props.appointment.van_datum, 'YYYYMMDD'), 'days') === 0){
      timeItem = <span className={props.classes.primaryItem}>{props.appointment.van_tijd + " - 24:00"}</span>
    }else if(props.selectedDate.diff(moment(props.appointment.tot_datum, 'YYYYMMDD'), 'days') === 0){
      timeItem = <span className={props.classes.primaryItem}>{"00:00 - " + props.appointment.tot_tijd}</span>
    }else if(props.selectedDate.diff(moment(props.appointment.van_datum, 'YYYYMMDD'), 'days') > 0
      && props.selectedDate.diff(moment(props.appointment.tot_datum, 'YYYYMMDD'), 'days') < 0){
      timeItem = <span className={props.classes.primaryItem}>{I18n.t('appointments.wholeDay')}</span>
    }
  }

  if(props.appointment.van_datum === props.appointment.tot_datum){
    if(moment(props.appointment.van_datum+props.appointment.van_tijd, 'YYYYMMDDhhmm').diff(moment()) <= 0 && moment(props.appointment.tot_datum+props.appointment.tot_tijd, 'YYYYMMDDhhmm').diff(moment()) >= 0){
      fromItem = <span className={props.classes.secondaryItem}>{I18n.t('appointments.now')}</span>
    }else if(moment(props.appointment.van_datum+props.appointment.van_tijd, 'YYYYMMDDhhmm').diff(moment()) < 0){
      fromItem = <span className={props.classes.secondaryItem}>{moment(props.appointment.tot_datum+props.appointment.tot_tijd, 'YYYYMMDDhhmm').fromNow()}</span>
    }else{
      fromItem = <span className={props.classes.secondaryItem}>{moment(props.appointment.van_datum+props.appointment.van_tijd, 'YYYYMMDDhhmm').fromNow()}</span>
    }
  }else{
    if(moment().diff(begin, 'days') === 0 && begin.diff(moment()) >= 0){
      fromItem = <span className={props.classes.secondaryItem}>{begin.fromNow()}</span>
    }else if(moment().diff(end, 'days') === 0 && end.diff(moment()) <= 0){
      fromItem = <span className={props.classes.secondaryItem}>{end.fromNow()}</span>
    }else{
      fromItem = <span className={props.classes.secondaryItem}>{I18n.t('appointments.now')}</span>
    }
  }

  let onderwerpen = props.appointment.onderwerpen.map((onderwerp, i) =>{
    if(props.appointment.onderwerpen.length === i + 1){
      return (<span key={i}>{onderwerp.onderwerp}</span>)
    }else{
      return(<span key={i}>{onderwerp.onderwerp} - </span>)
    }
  })

  return(
    <div onClick={props.onClick} className={props.classes.mainList}>
      <Grid container justify="center" >
        <Grid item container xs={2} md={1}>
          <Icon className={props.classes.icon} style={{color: props.appointment.kleuren.kleurcode}}>
            {props.appointment.iconen == null ?
              'timelapse'
              :
              props.appointment.iconen.icoon
            }
          </Icon>
        </Grid>
        <Grid item container xs={10} md={11}>
          <ListItemText
            primary={
              <span>
                { props.appointment.onderwerp !== null ?
                  props.appointment.onderwerpen.length > 0  ?
                    props.appointment.onderwerp+' - '
                    :
                    props.appointment.onderwerp
                  :
                  ''
                }
                {onderwerpen}
              </span>
            }
            secondary={
              <span>
                {timeItem}
                {fromItem}
              </span>
            }
            className={props.classes.mainListText}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default withTheme()(withStyles(styles)(Appointment))



// WEBPACK FOOTER //
// ./src/js/components/pages/appointment/Appointment.js